import React from 'react';
import cn from 'classnames';
import Guideline from '../Guideline';
import classes from './Guidelines.module.scss';

const Guidelines = ({
  className,
  onCheck,
  guidelines,
  guidelineChecked,
  listRef,
  userTimeZone,
  unbox,
}) => {
  return (
    <div
      className={cn(
        classes.wrapper,
        {
          [classes.unbox]: !!unbox,
        },
        className
      )}
      ref={listRef}
    >
      <span>Please check the guidelines below to proceed</span>
      {guidelines.map((g, i) => {
        return (
          <Guideline
            data={g}
            key={g.id}
            onCheck={onCheck(g.id)}
            checked={guidelineChecked[g.id]}
            userTimeZone={userTimeZone}
            newStyle={!!unbox}
            className={i === 0 ? classes.firstGuideline : ''}
          />
        );
      })}
    </div>
  );
};

export default Guidelines;
